import api from '@/api';
import { CURD } from '@xpeng/xdragon-ass-components';
import { message } from 'antd';
import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from '@/hooks/useTranslation';

const WorkingHourDetail = () => {
  const $ = useTranslation();
  const { modelCode } = useParams<{ modelCode: string; vin: string }>();

  const request = useCallback(
    async params => {
      params.size = params.pageSize;
      params.currentPage = params.current;
      const res = await api.sip.bookmap.getWorkHourList({
        ...params,
        smallCategoryCode: params.workCategory ? params.workCategory[2] : '',
        modelCode: modelCode
      });
      if (res.code === 200) {
        return {
          data: res.data.records ?? [],
          total: res.data.total,
          success: true
        };
      } else {
        return {
          data: [],
          total: 0,
          success: false,
          msg: res.msg
        };
      }
    },
    [modelCode]
  );

  const formItems = useMemo(() => {
    return [
      {
        type: 'cascader',
        name: 'workCategory',
        label: $('工时大类/小类'),
        options: async () => {
          const res = await api.sip.bookmap.allOperatePlaceAndWiType();
          if (res.code !== 200) {
            message.error(res.msg);
            return [];
          }
          return res.data;
        },
        props: {
          fieldNames: { label: 'name', value: 'code' },
          expandTrigger: 'hover'
        }
      },
      {
        type: 'input',
        name: 'wiCode',
        label: $('工时编码')
      },
      {
        type: 'input',
        name: 'wiName',
        label: $('工时名称')
      }
    ];
  }, [$]);

  const columns = useMemo(() => {
    return [
      {
        title: $('工时编码'),
        dataIndex: 'wiCode'
      },
      {
        title: $('工时名称'),
        dataIndex: 'wiName'
      },
      {
        title: $('故障部位'),
        dataIndex: 'faultPartName'
      },
      {
        title: $('工时大类'),
        dataIndex: 'largeCategoryName'
      },
      {
        title: $('工时小类'),
        dataIndex: 'smallCategoryName'
      },
      {
        title: $('工时数量'),
        dataIndex: 'wiQty'
      },
      {
        title: $('地区'),
        dataIndex: 'regionName'
      },
      {
        title: $('车系'),
        dataIndex: 'saleCarSeriesCode'
      },
      {
        title: $('销售车型名称'),
        dataIndex: 'saleCarTypeCode'
      },
      {
        title: $('配件号'),
        dataIndex: 'partNo'
      },
      {
        title: $('备注'),
        dataIndex: 'remark'
      }
    ];
  }, [$]);

  return (
    <CURD
      formItems={formItems}
      request={request}
      columns={columns}
      table={{ emptyPlaceholder: '-' }}
    />
  );
};

export default WorkingHourDetail;
